/* Casa de Ávila — scroll reveal + count-up
   Re-initializes on theme editor section load/reorder so
   customization in the theme editor doesn't break the motion. */
(function () {
  function animateCaCount(el) {
    var target = parseFloat(el.getAttribute('data-count'));
    var suffix = el.getAttribute('data-suffix') || '';
    if (isNaN(target)) return;
    var dur = 1300;
    var start = performance.now();
    function tick(now) {
      var p = Math.min(1, (now - start) / dur);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * eased) + suffix;
      if (p < 1) {
        requestAnimationFrame(tick);
      } else {
        el.textContent = target + suffix;
      }
    }
    requestAnimationFrame(tick);
  }

  function revealEl(el) {
    el.classList.add('is-visible');
    if (el.classList.contains('ca-stat-count')) {
      animateCaCount(el);
    }
  }

  function initCasaAvilaReveal(root) {
    root = root || document;
    var targets = root.querySelectorAll(
      '.ca-reveal-fade:not(.ca-observed), .ca-reveal-unroll:not(.ca-observed), .ca-seal-img:not(.ca-observed), .ca-stat-count:not(.ca-observed)'
    );
    if (!targets.length) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            revealEl(entry.target);
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    targets.forEach(function (el) {
      el.classList.add('ca-observed');
      io.observe(el);
      // Safety net: if the observer never fires for any reason (theme
      // editor preview, an iframe that reports zero size mid-render,
      // a slow/blocked script), force this element visible anyway after
      // a short delay. Content going permanently invisible is a worse
      // failure than a missed entrance animation.
      setTimeout(function () {
        if (!el.classList.contains('is-visible')) {
          revealEl(el);
          io.unobserve(el);
        }
      }, 1200);
    });
  }

  function initHeaderScroll() {
    var header = document.getElementById('ca-site-header');
    if (!header) return;
    window.addEventListener(
      'scroll',
      function () {
        header.classList.toggle('is-scrolled', window.scrollY > 40);
      },
      { passive: true }
    );
  }

  function initMobileNav() {
    var toggle = document.getElementById('ca-nav-toggle');
    var panel = document.getElementById('ca-mobile-panel');
    if (!toggle || !panel || toggle.dataset.caBound) return;
    toggle.dataset.caBound = 'true';
    toggle.addEventListener('click', function () {
      panel.classList.toggle('open');
    });
    panel.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        panel.classList.remove('open');
      });
    });
  }

  function ca_money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function ca_renderCart(cart) {
    var body = document.getElementById('ca-cart-body');
    var subtotalEl = document.getElementById('ca-cart-subtotal');
    var countEl = document.getElementById('ca-cart-count');
    if (!body) return;

    if (countEl) {
      countEl.textContent = cart.item_count;
      countEl.style.display = cart.item_count > 0 ? '' : 'none';
    }
    if (subtotalEl) subtotalEl.textContent = ca_money(cart.total_price);

    if (cart.item_count === 0) {
      body.innerHTML = '<p class="ca-cart-drawer__empty">Your cart is empty.</p>';
      return;
    }

    body.innerHTML = cart.items
      .map(function (item) {
        return (
          '<div class="ca-cart-line" data-key="' + item.key + '">' +
          '<img src="' + (item.image || '') + '&width=160" alt="' + item.product_title + '">' +
          '<div style="flex:1;">' +
          '<div class="ca-cart-line__name">' + item.product_title + '</div>' +
          (item.variant_title ? '<div class="ca-cart-line__variant">' + item.variant_title + '</div>' : '') +
          '<div class="ca-cart-line__row">' +
          '<div class="ca-cart-line__qty">' +
          '<button type="button" data-action="decrease">–</button>' +
          '<span>' + item.quantity + '</span>' +
          '<button type="button" data-action="increase">+</button>' +
          '</div>' +
          '<div class="ca-cart-line__price">' + ca_money(item.final_line_price) + '</div>' +
          '</div>' +
          '<button type="button" class="ca-cart-line__remove" data-action="remove">Remove</button>' +
          '</div>' +
          '</div>'
        );
      })
      .join('');
  }

  function ca_fetchCart() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(ca_renderCart);
  }

  function ca_changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(ca_renderCart);
  }

  function ca_openCart() {
    var drawer = document.getElementById('ca-cart-drawer');
    if (!drawer) return;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    ca_fetchCart();
  }

  function ca_closeCart() {
    var drawer = document.getElementById('ca-cart-drawer');
    if (!drawer) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
  }

  // Exposed globally so a future PDP / quick-add form can do:
  //   CasaAvilaCart.addItem(variantId, quantity)
  // and have it land in the drawer instead of reloading the page.
  window.CasaAvilaCart = {
    open: ca_openCart,
    close: ca_closeCart,
    refresh: ca_fetchCart,
    addItem: function (variantId, quantity) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw e; });
          return r.json();
        })
        .then(function () {
          ca_openCart();
        });
    }
  };

  function initCartDrawer() {
    var toggle = document.getElementById('ca-cart-toggle');
    var closeBtn = document.getElementById('ca-cart-close');
    var backdrop = document.getElementById('ca-cart-backdrop');
    var body = document.getElementById('ca-cart-body');
    if (!toggle || toggle.dataset.caBound) return;
    toggle.dataset.caBound = 'true';

    toggle.addEventListener('click', ca_openCart);
    if (closeBtn) closeBtn.addEventListener('click', ca_closeCart);
    if (backdrop) backdrop.addEventListener('click', ca_closeCart);

    if (body) {
      body.addEventListener('click', function (e) {
        var btn = e.target.closest('button[data-action]');
        if (!btn) return;
        var line = btn.closest('.ca-cart-line');
        var key = line.getAttribute('data-key');
        var qtySpan = line.querySelector('.ca-cart-line__qty span');
        var currentQty = parseInt(qtySpan.textContent, 10);

        if (btn.dataset.action === 'increase') {
          ca_changeLine(key, currentQty + 1);
        } else if (btn.dataset.action === 'decrease') {
          ca_changeLine(key, Math.max(0, currentQty - 1));
        } else if (btn.dataset.action === 'remove') {
          ca_changeLine(key, 0);
        }
      });
    }
  }

  function initAddToCartButtons() {
    if (document.body.dataset.caAtcBound) return;
    document.body.dataset.caAtcBound = 'true';
    document.body.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ca-add-to-cart]');
      if (!btn) return;
      var variantId = btn.getAttribute('data-ca-add-to-cart');
      if (!variantId) return;
      e.preventDefault();
      var qty = 1;
      var qtySourceId = btn.getAttribute('data-ca-qty-source');
      if (qtySourceId) {
        var qtyEl = document.getElementById(qtySourceId);
        if (qtyEl) qty = parseInt(qtyEl.textContent, 10) || 1;
      }
      var original = btn.textContent;
      btn.textContent = 'Adding…';
      window.CasaAvilaCart.addItem(variantId, qty)
        .then(function () {
          btn.textContent = original;
        })
        .catch(function () {
          btn.textContent = original;
          window.location.href = btn.href || '/cart';
        });
    });
  }

  function initPdpGallery(root) {
    root.querySelectorAll('.ca-pdp__gallery').forEach(function (gallery) {
      if (gallery.dataset.caBound) return;
      gallery.dataset.caBound = 'true';
      var main = gallery.querySelector('.ca-pdp__gallery-main img');
      gallery.querySelectorAll('.ca-pdp__thumb').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          gallery.querySelectorAll('.ca-pdp__thumb').forEach(function (t) { t.classList.remove('active'); });
          thumb.classList.add('active');
          if (main) {
            main.style.opacity = 0;
            setTimeout(function () {
              main.src = thumb.dataset.full;
              main.style.opacity = 1;
            }, 150);
          }
        });
      });
    });
  }

  function initPdpSizeSelect(root) {
    root.querySelectorAll('.ca-pdp__size-options').forEach(function (group) {
      if (group.dataset.caBound) return;
      group.dataset.caBound = 'true';
      var pdpRoot = group.closest('.ca-pdp');
      var addBtn = pdpRoot ? pdpRoot.querySelector('[data-ca-add-to-cart]') : null;
      var buyBtn = pdpRoot ? pdpRoot.querySelector('.ca-pdp__ctas .ca-btn-line') : null;
      var totalEl = pdpRoot ? pdpRoot.querySelector('.ca-pdp__total') : null;
      var qtyEl = pdpRoot ? pdpRoot.querySelector('.ca-pdp__stepper span') : null;

      function refreshTotal(price) {
        if (!totalEl) return;
        var qty = qtyEl ? parseInt(qtyEl.textContent, 10) || 1 : 1;
        totalEl.textContent = '$' + ((price * qty) / 100).toFixed(2);
      }

      group.querySelectorAll('.ca-pdp__size-opt').forEach(function (opt) {
        opt.addEventListener('click', function () {
          if (opt.disabled) return;
          group.querySelectorAll('.ca-pdp__size-opt').forEach(function (o) { o.classList.remove('active'); });
          opt.classList.add('active');
          var variantId = opt.dataset.variantId;
          var price = parseInt(opt.dataset.price, 10);
          if (addBtn) addBtn.setAttribute('data-ca-add-to-cart', variantId);
          if (buyBtn) buyBtn.setAttribute('data-variant-id', variantId);
          refreshTotal(price);
        });
      });

      // quantity stepper also needs to refresh the total using the
      // currently active size option's price
      if (qtyEl) {
        var activeOpt = group.querySelector('.ca-pdp__size-opt.active');
        var basePrice = activeOpt ? parseInt(activeOpt.dataset.price, 10) : null;
        var observer = new MutationObserver(function () {
          if (basePrice) refreshTotal(basePrice);
        });
        observer.observe(qtyEl, { characterData: true, childList: true, subtree: true });
      }
    });
  }

  function initPdpQuantity(root) {
    root.querySelectorAll('.ca-pdp__stepper').forEach(function (stepper) {
      if (stepper.dataset.caBound) return;
      stepper.dataset.caBound = 'true';
      var span = stepper.querySelector('span');
      var buttons = stepper.querySelectorAll('button');
      var minus = buttons[0];
      var plus = buttons[1];
      var qty = parseInt(span.textContent, 10) || 1;
      minus.addEventListener('click', function () {
        qty = Math.max(1, qty - 1);
        span.textContent = qty;
      });
      plus.addEventListener('click', function () {
        qty = qty + 1;
        span.textContent = qty;
      });
    });
  }

  function initPdpBuyNow(root) {
    root.querySelectorAll('.ca-pdp__ctas .ca-btn-line[data-variant-id]').forEach(function (btn) {
      if (btn.dataset.caBound) return;
      btn.dataset.caBound = 'true';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var variantId = btn.getAttribute('data-variant-id');
        var pdpRoot = btn.closest('.ca-pdp');
        var qtyEl = pdpRoot ? pdpRoot.querySelector('.ca-pdp__stepper span') : null;
        var qty = qtyEl ? parseInt(qtyEl.textContent, 10) || 1 : 1;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: qty })
        }).then(function () {
          window.location.href = '/checkout';
        });
      });
    });
  }

  function initPdpAccordion(root) {
    root.querySelectorAll('.ca-pdp__acc-item').forEach(function (item) {
      if (item.dataset.caBound) return;
      item.dataset.caBound = 'true';
      var head = item.querySelector('.ca-pdp__acc-head');
      var body = item.querySelector('.ca-pdp__acc-body');
      head.addEventListener('click', function () {
        var isOpen = item.classList.contains('open');
        var group = item.parentElement.querySelectorAll('.ca-pdp__acc-item');
        group.forEach(function (i) {
          i.classList.remove('open');
          i.querySelector('.ca-pdp__acc-body').style.maxHeight = null;
        });
        if (!isOpen) {
          item.classList.add('open');
          body.style.maxHeight = body.scrollHeight + 'px';
        }
      });
    });
  }

  function initPdp(root) {
    initPdpGallery(root);
    initPdpSizeSelect(root);
    initPdpQuantity(root);
    initPdpBuyNow(root);
    initPdpAccordion(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCasaAvilaReveal(document);
    initHeaderScroll();
    initMobileNav();
    initCartDrawer();
    initAddToCartButtons();
    initPdp(document);
  });

  document.addEventListener('shopify:section:load', function (e) {
    initCasaAvilaReveal(e.target);
    initHeaderScroll();
    initMobileNav();
    initCartDrawer();
    initAddToCartButtons();
    initPdp(e.target);
  });
})();